import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import SearchItems from './SearchItems';
import SearchCategoryItems from './SearchCategoryItems';
import AvailableItem from './AvailableItem';
import { connect } from 'react-redux';

// Built once: creating them inside render remounts the detail page on every render, and a browser Back
// (two unbatched renders) then fetched both the previous and the current product, the slower one winning.
const ItemPage = AvailableItem('items');
const BundlePage = AvailableItem('bundles');
const AddOnPage = AvailableItem('add_ons');

const Shop = (props) => {
  useEffect(() => {
    if (
      props.parsedStorefrontSettings &&
      props.parsedStorefrontSettings.storefrontShopSetting.overrideCatalogUrl
    ) {
      window.location.replace(
        props.parsedStorefrontSettings.storefrontShopSetting.overrideCatalogUrl
      );
    }
  }, []);

  return (
    <Switch>
      <Route exact path='/shop' component={SearchItems} />
      <Route path='/shop/items/:id/:slug' component={ItemPage} />
      <Route path='/shop/items/:id' component={ItemPage} />
      <Route path='/shop/bundles/:id/:slug' component={BundlePage} />
      <Route path='/shop/bundles/:id' component={BundlePage} />
      <Route path='/shop/addons/:id/:slug' component={AddOnPage} />
      <Route path='/shop/addons/:id' component={AddOnPage} />
      <Route path='/shop/:category(.+)' component={SearchCategoryItems} />
    </Switch>
  );
};

const mapStateToProps = (state) => {
  const { parsedStorefrontSettings } = state.locations;
  return { parsedStorefrontSettings };
};
export default connect(mapStateToProps)(Shop);
